<template>
  <div>
    <Header></Header>
    <div class="container">
      <div class="form-container">
        <span class="succ"><i class="el-icon-check"></i> 密码修改成功</span> <a href="/login" class="loginnow">马上去登录></a>
      </div>
    </div>
  </div>
</template>
<style scoped>
.container {
  width: 980px;
  margin: 0 auto;
  margin-top:16px;
}
.form-container {
  width: 480px;
  margin: 0 auto;
}
a {
  font-size: 13px;
  text-decoration: underline;
}
.succ {
  color: rgb(40, 219, 160);
  font-size:18px;
}
.el-icon-check{font-size:22px;font-weight: bold;}
</style>
<script>
import Header from "./headernew.vue";
export default {
  components: {
    Header,
  },
};
</script>